import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faBriefcase,
  faBuilding,
  faCheck,
  faCompass,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import talentImage from "../assets/images/Engineering and Technical Experts.png";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import "../assets/css/ModernPages.css";

const LandingPage = () => (
  <main className="modern_page">
    <SiteHeader />
    <section className="modern_hero shell">
      <div className="hero_copy">
        <p className="eyebrow">
          <span /> Talent, placed with purpose
        </p>
        <h1>
          People who move businesses <em>forward.</em>
        </h1>
        <p className="hero_intro">
          Staffing Mart brings ambitious people and growing teams together
          through thoughtful recruitment, flexible staffing, and human-first
          support.
        </p>
        <div className="hero_actions">
          <Link to="/services" className="primary_action">
            Explore our services <FontAwesomeIcon icon={faArrowRight} />
          </Link>
          <Link to="/contact" className="text_action">
            Talk to our team <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </div>
        <div className="hero_proof">
          <div>
            <strong>01</strong>
            <span>Clearer hiring</span>
          </div>
          <div>
            <strong>02</strong>
            <span>Better-fit talent</span>
          </div>
          <div>
            <strong>03</strong>
            <span>Lasting partnerships</span>
          </div>
        </div>
      </div>
      <div className="hero_visual">
        <div className="hero_visual_label">
          The right fit
          <br />
          <strong>every time.</strong>
        </div>
        <img
          src={talentImage}
          alt="Technical professionals supported by Staffing Mart"
        />
        <div className="hero_stat">
          <span className="stat_dot" /> Human-led
          <br />
          <strong>recruitment</strong>
        </div>
      </div>
    </section>
    <section className="pathways shell">
      <div className="section_heading">
        <p className="eyebrow">
          <span /> Find your next move
        </p>
        <h2>
          One partner. <em>Two clear paths.</em>
        </h2>
      </div>
      <div className="pathway_grid">
        <Link
          to="/contact?type=employer"
          className="pathway_card pathway_employer"
        >
          <div className="pathway_icon">
            <FontAwesomeIcon icon={faBuilding} />
          </div>
          <p className="card_kicker">For employers</p>
          <h3>Build the team your next chapter needs.</h3>
          <span>
            Find talent <FontAwesomeIcon icon={faArrowRight} />
          </span>
        </Link>
        <Link
          to="/contact?type=job-seeker"
          className="pathway_card pathway_candidate"
        >
          <div className="pathway_icon">
            <FontAwesomeIcon icon={faUserTie} />
          </div>
          <p className="card_kicker">For job seekers</p>
          <h3>Find work that fits your ambition.</h3>
          <span>
            Explore opportunities <FontAwesomeIcon icon={faArrowRight} />
          </span>
        </Link>
      </div>
    </section>
    <section className="home_services shell">
      <div className="section_heading split_heading">
        <div>
          <p className="eyebrow">
            <span /> What we do
          </p>
          <h2>
            Hiring, without
            <br />
            <em>the noise.</em>
          </h2>
        </div>
        <Link to="/services" className="text_action">
          View all services <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </div>
      <div className="service_strip">
        <div>
          <FontAwesomeIcon icon={faCompass} />
          <span>
            Recruitment &<br />
            executive search
          </span>
        </div>
        <div>
          <FontAwesomeIcon icon={faBriefcase} />
          <span>
            Flexible staffing
            <br />
            solutions
          </span>
        </div>
        <div>
          <FontAwesomeIcon icon={faCheck} />
          <span>
            Assessment &<br />
            talent advisory
          </span>
        </div>
      </div>
    </section>
    <SiteFooter />
  </main>
);

export default LandingPage;
